var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoContacta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.061,
    height: 36.408,
    viewBox: "0 0 50.061 36.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    "data-name": "Trazado 137",
    d: "M47.967-16H2.093A2.093,2.093,0,0,0,0-13.907V18.314a2.093,2.093,0,0,0,2.093,2.093H47.967a2.093,2.093,0,0,0,2.093-2.093V-13.907a2.093,2.093,0,0,0-.613-1.48A2.093,2.093,0,0,0,47.967-16ZM44.9-12.974,27.806,4.092H22.254L5.165-12.974ZM3.026,17.381V-10.835L20.98,7.142h8.1L47.034-10.835V17.381Z",
    transform: "translate(0 16)",
    fill: "#6a767d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_187",
    "data-name": "Grupo 187",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_186",
    "data-name": "Grupo 186",
    transform: "translate(0 -16)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_136",
    "data-name": "Trazado 136",
    d: "M-5-21H67.815V38.162H-5Z",
    transform: "translate(-6.377 9.623)",
    fill: "#6a767d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoContacta);
export default __webpack_public_path__ + "static/media/ico_contacta.cdfc4764f180868279f74ea4caa64322.svg";
export { ForwardRef as ReactComponent };